import { useState } from 'react';
/* eslint-disable import/no-named-as-default */
import { AlertBox, Button, useDeviceContext } from '@spotahome/ui-library';

import PropTypes from 'prop-types';

import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import { ListingShape } from '../../shapes/listing';

import ListingSocialButtons from '../ListingSocialButtons';
import AlternativesModal from '../AlternativesModal/AlternativesModal';

import './BookNowCardNotAvailable.scss';

const BookNowCardNotAvailable = ({
  listing,
  deviceType,
  moveIn = '',
  moveOut = ''
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const isShowAlternativesExperiment =
    useSoyuzExperiment('ShowAlternativesExperiment').get('behaviour') ===
    'variant';
  const { deviceOS } = useDeviceContext();
  return (
    <div
      className="booknow-card-not-available"
      data-test="booknow-card-not-available"
    >
      <div className="booknow-card-not-available__title">
        <ListingSocialButtons
          deviceType={deviceType}
          listingId={listing.id}
          deviceOS={deviceOS}
        />
      </div>
      <div className="booknow-card-not-available__body">
        <AlertBox
          message={
            isShowAlternativesExperiment
              ? trans(
                  'listing.book-now-not-available.alertbox-message.alternatives'
                )
              : trans('listing.book-now-not-available.alertbox-message')
          }
          roundedCorners
          theme={isShowAlternativesExperiment ? 'tertiary' : 'info'}
        />
      </div>
      {isShowAlternativesExperiment ? (
        <>
          <Button
            color="primary"
            size="large"
            className="booknow-card-not-available__alternatives-button"
            onClick={() => setModalOpen(true)}
          >
            {trans('alternatives_modal.button')}
          </Button>
          <AlternativesModal
            isOpen={isModalOpen}
            isClosable
            listingId={listing.id}
            moveIn={moveIn}
            moveOut={moveOut}
            cityId={listing.cityId}
            handleClose={() => setModalOpen(false)}
          />
        </>
      ) : null}
    </div>
  );
};

BookNowCardNotAvailable.propTypes = {
  listing: PropTypes.shape(ListingShape).isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired,
  moveIn: PropTypes.string,
  moveOut: PropTypes.string
};

export default BookNowCardNotAvailable;
